var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBusinessCenterWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.4,14.9v-.8H3.808L3.8,17.3a1.594,1.594,0,0,0,1.6,1.6H16.6a1.594,1.594,0,0,0,1.6-1.6V14.1H12.6v.8Zm8-7.2H14.192V6.1l-1.6-1.6h-3.2l-1.6,1.6V7.7H4.6A1.6,1.6,0,0,0,3,9.3v2.4a1.594,1.594,0,0,0,1.6,1.6H9.4V11.7h3.2v1.6h4.8A1.6,1.6,0,0,0,19,11.7V9.3A1.6,1.6,0,0,0,17.4,7.7Zm-4.8,0H9.4V6.1h3.2Z",
    transform: "translate(-3 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessCenterWhite);
export default __webpack_public_path__ + "static/media/iconBusinessCenterWhite.bcd5be9f6f5623b58911ef10896b5946.svg";
export { ForwardRef as ReactComponent };